import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";
import {
  Search,
  User,
  Mail,
  Phone,
  Wallet,
  Globe,
  Calendar,
  Users,
  CheckCircle,
  XCircle,
  Edit,
  Trash2,
  Crown,
  Clock,
  Filter,
  RefreshCw,
} from "lucide-react";
import "./UsersSupport.css";

function UsersSupport({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [showEdit, setShowEdit] = useState(false);

  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const deleteUser = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        let payload = { id: id };
        setLoader(true);
        await api.deleteUser(payload);
        setData([]);
        setLoader(false);
        alert("User deleted successfully");
      } catch (error) {
        console.log(error);
        setLoader(false);
        alert("Failed to delete user");
      }
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = { email: searchMail };
      const res = await api.getUserByMail(payload);
      if (res?.success) {
        setData(res?.user);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const handleReset = () => {
    setSearchMail("");
    setData([]);
    setResetPage(!resetPage);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const makeSubscribeUser = async (email) => {
    if (window.confirm("Make this user a subscribed member?")) {
      try {
        let payload = { email: email };
        setLoader(true);
        const userData = await api.SuperAdminMakePaidUser(payload);
        if (userData?.success) {
          alert(userData?.msg);
          handleSearch();
        } else {
          alert(userData?.msg || "Something went wrong");
        }
        setLoader(false);
      } catch (error) {
        console.log(error?.message);
        setLoader(false);
      }
    }
  };

  return (
    <>
      <div className="support-users-container">
        <div className="support-users-content">
          <div className="support-users-header">
            <div className="support-users-header-content">
              <div className="support-users-header-left">
                <div className="support-users-header-main">
                  <div className="support-users-header-icon-wrapper">
                    <div className="support-users-header-icon-bg">
                      <User size={28} className="support-users-header-icon" />
                    </div>
                  </div>
                  <div className="support-users-header-text">
                    <h1 className="support-users-title">Search User</h1>
                    <p className="support-users-subtitle">
                      Find and manage users by email address
                    </p>
                  </div>
                </div>
              </div>

              <div className="support-users-header-right">
                <div className="support-users-search-section">
                  <div className="support-users-search-wrapper">
                    <div className="support-users-search-input">
                      <Search size={20} className="support-users-search-icon" />
                      <input
                        type="text"
                        placeholder="Search user by email address..."
                        value={searchMail}
                        onChange={(e) => setSearchMail(e.target.value)}
                        onKeyPress={handleKeyPress}
                        className="support-users-search-field"
                      />
                      {searchMail && (
                        <button
                          className="support-users-clear-btn"
                          onClick={() => setSearchMail("")}
                        >
                          ×
                        </button>
                      )}
                    </div>
                    <div className="support-users-action-buttons-row">
                      <button
                        className="support-users-search-btn"
                        onClick={handleSearch}
                      >
                        <Search size={18} />
                        Search
                      </button>

                      <button
                        className="support-users-reset-btn"
                        onClick={handleReset}
                      >
                        <RefreshCw size={18} />
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="support-users-content-card">
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfUser={noOfUser}
              limit={limit}
              deleteUser={deleteUser}
              adminType={adminType}
              handleShowEdit={handleShowEdit}
              makeSubscribeUser={makeSubscribeUser}
            />
          </div>
        </div>
      </div>

      <Modal
        show={showEdit}
        size="lg"
        onHide={handleCloseEdit}
        centered
        className="support-users-modal"
      >
        <Modal.Body>
          <div className="support-users-otpModalMain">
            <div className="support-users-closeIcon" onClick={handleCloseEdit}>
              <i className="fa-solid fa-xmark" />
            </div>
            <EditUserData
              handleSearch={handleSearch}
              setShow={setShowEdit}
              selectedData={selectedData}
            />
          </div>
        </Modal.Body>
      </Modal>

      {loader && <Loader />}
    </>
  );
}

// Table component remains exactly the same as before...

const Table = ({
  data,
  page,
  setPage,
  noOfUser,
  limit,
  deleteUser,
  adminType,
  handleShowEdit,
  makeSubscribeUser,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    if (!nextPayment) return false;
    let currentDate = new Date();
    let endDate = new Date(nextPayment);
    return currentDate < endDate;
  };

  return (
    <>
      <div className="support-users-table-container">
        <div className="support-users-table-header">
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Calendar size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Joined At</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <User size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Name</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Mail size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Email</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Phone size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Phone</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Wallet size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Wallet</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Globe size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Country</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Calendar size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">DOB</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Users size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Gender</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <CheckCircle size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Email Verified</span>
          </div>
          <div className="support-users-table-header-item">
            <div className="support-users-header-icon-bg-sm">
              <Filter size={16} className="support-users-header-icon-sm" />
            </div>
            <span className="support-users-header-text">Actions</span>
          </div>
        </div>

        <div className="support-users-table-body">
          {data.length > 0 ? (
            data.map((item, key) => (
              <div key={key} className="support-users-table-row">
                <div className="support-users-table-cell">
                  <div className="support-users-joined-at">
                    <Calendar size={14} className="support-users-cell-icon" />
                    <span className="support-users-date-text">
                      {formatDate(item?.createdAt)}
                    </span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-name">
                    <User size={14} className="support-users-cell-icon" />
                    <span>{item?.name || "-"}</span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-email">
                    <Mail size={14} className="support-users-cell-icon" />
                    <span className="support-users-email-text">
                      {item?.email}
                    </span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-phone">
                    <Phone size={14} className="support-users-cell-icon" />
                    <span>{item?.phone ? item?.phone : "-"}</span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-wallet">
                    <Wallet size={14} className="support-users-cell-icon" />
                    <span className="support-users-wallet-text">
                      {item?.wallet ? `$${item?.wallet}` : "-"}
                    </span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-country">
                    <Globe size={14} className="support-users-cell-icon" />
                    <span>{item?.country ? item?.country : "-"}</span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-dob">
                    <Calendar size={14} className="support-users-cell-icon" />
                    <span className={"w-max"}>{item?.dob || "-"}</span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-user-gender">
                    <Users size={14} className="support-users-cell-icon" />
                    <span className="support-users-gender-text">
                      {item?.gender || "-"}
                    </span>
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-email-verified">
                    {item?.emailVerified ? (
                      <div className="support-users-verified-badge">
                        <CheckCircle
                          size={14}
                          className="support-users-verified-icon"
                        />
                        <span>Verified</span>
                      </div>
                    ) : (
                      <div className="support-users-not-verified-badge">
                        <XCircle
                          size={14}
                          className="support-users-not-verified-icon"
                        />
                        <span>Not Verified</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="support-users-table-cell">
                  <div className="support-users-actions">
                    {adminType == "sackAdmin755" && (
                      <div className="support-users-subscription-section">
                        {item?.subscription?.length > 0 ? (
                          <>
                            {checkSubscription(
                              item?.subscription[0]?.nextPayment,
                            ) ? (
                              <div className="support-users-subscribed-badge">
                                <Crown size={14} />
                                <span>Subscribed</span>
                              </div>
                            ) : (
                              <>
                                <div className="support-users-expired-badge">
                                  <Clock size={14} />
                                  <span>Expired</span>
                                </div>
                                <button
                                  className="support-users-make-subscribe-btn"
                                  onClick={() => makeSubscribeUser(item?.email)}
                                >
                                  <Crown size={14} />
                                  <span>Make Subscribe</span>
                                </button>
                              </>
                            )}
                          </>
                        ) : (
                          <button
                            className="support-users-make-subscribe-btn"
                            onClick={() => makeSubscribeUser(item?.email)}
                          >
                            <Crown size={14} />
                            <span>Make Subscribe</span>
                          </button>
                        )}
                      </div>
                    )}

                    <div className="support-users-action-buttons">
                      {adminType == "sackAdmin755" && (
                        <button
                          className="support-users-edit-btn"
                          onClick={() => handleShowEdit(item)}
                          title="Edit User"
                        >
                          <Edit size={16} />
                        </button>
                      )}
                      <button
                        className="support-users-delete-btn"
                        onClick={() => deleteUser(item?._id)}
                        title="Delete User"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="support-users-empty-state">
              <div className="support-users-empty-icon-wrapper">
                <div className="support-users-empty-icon-bg">
                  <User size={32} className="support-users-empty-icon" />
                </div>
              </div>
              <h3 className="support-users-empty-title">No Users Found</h3>
              <p className="support-users-empty-description">
                Search for users by email address to view their details
              </p>
              <div className="support-users-empty-hint">
                <Search size={16} />
                <span>Enter an email address in the search bar above</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UsersSupport;
